<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <Loading v-if="loading"/>
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="col-auto">
                <card shadow class="card-profile mt--400 ml-5 mr-5" no-body>

                     <div class="row justify-content-center mb-5">
                    <div class="col-lg-3 order-lg-2">
                        <div class="card-profile-image">
                            <a href="#">
                                <img v-lazy="'img/chart.png'" class="rounded-circle bg-white">
                            </a>
                        </div>
                        
                    </div>
                    <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                        <div class="card-profile-actions py-4 mt-lg-0">
                            <a class="btn btn-primary float-right" href="/#/absent"><i class="ni ni-circle-08 nix3"></i> Absent Staff</a>
                        </div>
                    </div>
                    <div class="col-lg-4 order-lg-1">
                        <div class="card-profile-stats d-flex justify-content-center">
                            <h2 class="col-11 text-center font-weight-bold">REPORTS</h2>
                                
                        </div>
                    </div>
                </div>
                   <!-- <div class="card-header text-center">
                    <div class="row">
                    <h3 class="col-10">
                        Reports
                    </h3>
                     <a class="btn btn-warning col-2 float-right" href="/#/absent"><i class="ni ni-circle-08 nix3"></i> Absent Staff</a>
                    </div>

                   </div> -->

                   
                    <div class="p-4">
                        <div class="">
                            <div class="row justify-content-center mt-2">
                                    <div class="col-3">
                                    <label>Select Date Range To Filter Report :</label>
                                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                                        <flat-picker  slot-scope="{focus, blur}" 
                                                    @on-open="focus" 
                                                    @on-close="blur"                                                    
                                                    :config="{allowInput: true, mode: 'range'}"
                                                    class="form-control datepicker"
                                                    v-model="form.range">
                                        </flat-picker>
                                    </base-input>
                                    </div>

                                    <div class="col-3">
                                        <label>Champion Phone :</label>
                                        <base-input placeholder="2547XXXXXXXX" v-model="form.mobile"></base-input>
                                    </div>

                                     <div class="col-2">
                                        <b-form-group label="Type of Task :" v-slot="{ ariaDescribedby }">
                                            <b-form-checkbox-group
                                                id="checkbox-group-1"
                                                v-model="form.task"
                                                :options="tasks"
                                                :aria-describedby="ariaDescribedby"
                                                value-field="TaskID"
                                                text-field="TaskName"
                                                stacked
                                            ></b-form-checkbox-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col-3">
                                        <label>Departments :</label>
                                        <b-select  v-model="form.dept">
                                            <b-select-option v-for = "dept in depts" :key="dept.DepartmentID" :value="dept.DepartmentID"> {{ dept.Name }} </b-select-option>
                                        </b-select>
                                    </div>
                                    <div class="col-1" >
                                        <br>
                                        <!-- <div @click="generateReport" v-if ="!loading" class="pointer icon icon-shape bg-gradient-primary rounded-circle text-white mb-3"><i class="ni ni-cloud-download-95"></i></div> -->
                                        <!-- <div @click="generateReport" v-if ="!loading" class="pointer icon icon-shape bg-gradient-primary rounded-circle text-white mb-3"><i class="ni ni-cloud-download-95"></i></div> -->
                                        <!-- <div @click="getReport" v-if ="!loading" class="pointer icon icon-shape bg-gradient-primary rounded-circle text-white mb-3"><i class="ni ni-cloud-download-95"></i></div> -->
                                      <div v-if ="!loading" type="button" class="pointer icon icon-shape bg-gradient-primary rounded-circle text-white mb-3" v-on:click="download"><i class="ni ni-cloud-download-95"></i></div>  
                                        
                                    </div>
                           
                            </div>

                            <div class="row justify-content-center mt-2">
                                 <div class="col">
                                    <table class="table table-striped table-responsive" id="myTable">
                                    <thead>
                                        <tr>                                
                                            <th scope="col">Champion</th>
                                            <th scope="col">Champion Phone</th>
                                            <th scope="col">Task</th>
                                            <th scope="col">Branch</th>
                                            <th scope="col">Department</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Time</th>
                                            <th scope="col">Recommended Time</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Comments</th>
                                            <th scope="col">Location</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(staff,index) in report" :key="index" >
                                       
                                        <td>{{ staff["Staff.OfficialName"]}} </td>
                                        <td>{{ staff["Staff.MobileNumber"]}}</td>
                                        <td>{{ staff["StaffTask.TaskName"]}}</td>
                                        <td>{{ staff["Branch.Name"] }}</td>
                                        <td>{{ staff["Staff.Department.Name"] }}</td>
                                        <td>{{ moment(staff.TrxDate).subtract(3,'hours').format("MMM Do YY")}}</td>
                                        <td>{{ moment(staff.TrxDate).subtract(3,'hours').format("HH:mm")}}</td>
                                        <td>{{ staff["StaffTask.RecommendedTime"]}}</td>
                                        <td>{{`${humanizeDuration(moment.duration(Math.abs(timediff(staff)), 'minutes').asMilliseconds())} ${timediff(staff) > 0 ? "late 👿":"early 😇"}`}}</td>
                                        <td>{{ staff.Comments }}</td>
                                        <td>{{ staff.LocationName }}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import $ from 'jquery'
import 'datatables.net-dt'

import '../../node_modules/datatables.net-buttons/js/jquery.dataTables.min.js'
import '../../node_modules/datatables.net-buttons/js/dataTables.buttons.js'
import '../../node_modules/datatables.net-buttons/js/jszip.min.js'
import '../../node_modules/datatables.net-buttons/js/pdfmake.min.js'
import '../../node_modules/datatables.net-buttons/js/vfs_fonts.js'
import '../../node_modules/datatables.net-buttons/js/buttons.html5.min.js'
import '../../node_modules/datatables.net-bs4/js/dataTables.bootstrap4.js'

// import '../../node_modules/datatables.net-buttons-dt/css/buttons.dataTables.css'
// import '../../node_modules/datatables.net-bs4/css/dataTables.bootstrap4.css'




import moment from "moment"
import _ from "lodash"
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from './DataLoading'
import humanizeDuration  from 'humanize-duration'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import XLSX from 'xlsx';

export default {
    components: { 
       flatPicker,
       Loading,
       LottieAnimation,
    },
    data(){
        return{
      
            form: {
                range: `${moment().subtract("1","days").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")} `,
                mobile:'',
                task:_.map(this.$store.state.tasks, 'TaskID')
            },
            attendance:_.groupBy(this.$store.state.attendance, 'rider.MobileNumber'),
            timestamp:moment().format(),
            report:this.$store.state.report,
            loading:false,    
            tasks:this.$store.state.tasks,
            depts:this.$store.state.departments
            
        }
    },
    mounted(){
        
        this.getReport()
        
    },
    computed:{
        moment(){
              return moment
        },
          humanizeDuration(){
              return humanizeDuration
        },
                
    },
    methods:{
        download : function() {
            this.loading = true  
            var payload = { dept :this.form.dept, mobile:this.form.mobile ,task:this.form.task , fromdate:this.form.range.split("to")[0].trim() , todate:this.form.range.split("to")[1].trim() ? this.form.range.split("to")[1].trim() : this.form.range.split("to")[0].trim() }
            new Promise(( res, rej ) => {
            fetch(`https://stats.little.bz/attendance/report/${this.$store.state.company.CorporateID}`, 
            {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization':this.$store.state.token
                },
                body:JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                     this.loading = false;  
                        if(data.success){
                            let attendance_data = [];

                            for (var key in data.attendance){

                                attendance_data[key] =
                                    {
                                        Date: moment(data.attendance[key].TrxDate).subtract(3,'hours').format('YYYY-MM-DD'),
                                        Time: moment(data.attendance[key].TrxDate).subtract(3,'hours').format('HH:mm'),
                                        Task: data.attendance[key]['StaffTask.TaskName'],
                                        MobileNumber: data.attendance[key].MobileNumber,
                                        StaffName: data.attendance[key]['Staff.OfficialName'],
                                        Email: data.attendance[key]['Staff.CompanyEmail'],
                                        Branch: data.attendance[key]['Branch.Name'],
                                        BranchAddress: data.attendance[key]['Branch.Address'],
                                        BranchCity: data.attendance[key]['Branch.City'],
                                        BranchCountry: data.attendance[key]['Branch.Country'],
                                        Department: data.attendance[key]['Staff.Department.Name'],
                                        LocationScanned: data.attendance[key].LocationName
                                    }
                            }

                            const workSheet = XLSX.utils.json_to_sheet(attendance_data);
                            // delete (workSheet['O2'])
                            const workBook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(workBook, workSheet, 'data');

                            //Generate Buffer
                            XLSX.write(workBook, { bookType: 'xlsx', type: "buffer" });

                            //Binary String
                            XLSX.write(workBook, { bookType: 'xlsx', type:'binary'})
                            XLSX.writeFile(workBook, "Data.xlsx")

                            // res();
                        }else{
                            res();
                        }   
                })
                .catch(() => {
                    this.loading = false    
                })
            })

        },
        getNow(){
            this.timestamp = moment().format();
        },
        timediff(staff){
            return moment(staff.TrxDate).subtract(3,'hours').diff(moment(`${moment(staff.TrxDate).startOf('day').format('YYYY-MM-DD')} ${staff["StaffTask.RecommendedTime"]}`), 'minutes')
        },
        getReport(){
            this.loading = true               
                
            this.$store.dispatch("getReport",{ dept :this.form.dept, mobile:this.form.mobile ,task:this.form.task , fromdate:this.form.range.split("to")[0].trim() , todate:this.form.range.split("to")[1].trim() ? this.form.range.split("to")[1].trim() : this.form.range.split("to")[0].trim() })
            .then(() => {
                this.report = this.$store.state.report     
                this.loading = false
                $('#myTable').DataTable().destroy();
                this.$nextTick().then(()=>$('#myTable').DataTable({
                        dom: 'Bfrtip',
                        buttons: [
                            'copyHtml5',
                            'excelHtml5',
                            'csvHtml5',
                            'pdfHtml5'
                        ]
                    }))
            })
            .catch(() => {
                 this.loading = false    
            })
        },

        fetchData() {
            var payload = { dept :this.form.dept, mobile:this.form.mobile ,task:this.form.task , fromdate:this.form.range.split("to")[0].trim() , todate:this.form.range.split("to")[1].trim() ? this.form.range.split("to")[1].trim() : this.form.range.split("to")[0].trim() }
            return new Promise(( res, rej ) => {
                    fetch(`https://stats.little.bz/attendance/report/${this.$store.state.company.CorporateID}`, 
                    {
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization':this.$store.state.token
                        },
                        body:JSON.stringify(payload)
                    
                    })
                    .then(response => response.json())
                    .then(data => {
                            if(data.success){
                                return data.attendance;
   
                               const Reportdata = XLSX.utils.json_to_sheet(this.items)
                               // const Reportdata = XLSX.utils.json_to_sheet(data.attendance)
                              const wb = XLSX.utils.book_new()
                              XLSX.utils.book_append_sheet(wb, data, 'data')
   
                                res();
                            }else{
                                res();
                            }   
                    })
                })
        }
    }
};
</script>

<style>

</style>
